import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { logInOutline } from "ionicons/icons";
import { RouteProps, useHistory } from "react-router-dom";
import { LOGOUT_URL } from "../utils/urlUtils";
import { IS_MOBILE } from "../utils/deviceDetectionUtil";

// @author E42303 Judhjit Ganguli
const isWebMode = Capacitor.getPlatform().includes("web");

interface LogoutSuccessProps extends RouteProps {
  onLogin: any;
}

const LogoutSuccess: React.FC<LogoutSuccessProps> = ({ onLogin }) => {
  const history = useHistory();

  const openCapacitorSite = async (url: string) => {
    await Browser.open({ url: url, presentationStyle: "popover" });
  };

  function handleCompleteLogout() {
    console.log("Complete Logout");
    !IS_MOBILE
      ? window.location.replace(LOGOUT_URL + "")
      : openCapacitorSite(LOGOUT_URL + "");
  }
  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar className="ion-no-padding cmed_mobile_toolbar">
          <IonTitle className="custom_title_cmed_mobile">CME Direct</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <IonCard>
            <IonCardHeader>
              <IonCardTitle>
                You have been logged out of this session.
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <center>
                <IonButton
                  fill="clear"
                  onClick={() => {
                    localStorage.setItem("loggedOut", "false");
                    sessionStorage.removeItem("alert_status_filters");
                    onLogin();
                  }}
                >
                  Login
                  <IonIcon icon={logInOutline} slot="start"></IonIcon>
                </IonButton>
              </center>
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
      <IonFooter className="ion-no-border">
        <p className="ion-text-center">
          © {new Date().getFullYear()} CME Group Inc.
        </p>
      </IonFooter>
    </IonPage>
  );
};

export default LogoutSuccess;
